import { Box } from "@mui/material";
import { Breadcrumbs } from "components/layout/navigation/Breadcrumbs";
import { HeadingNav } from "components/layout/navigation/HeadingNav";
import { Heading } from "components/layout/page/Heading";
import { MaxWidthPage } from "components/layout/page/MaxWidthPageWithHeading";
import { Fake } from "components/layout/skeleton/Fake";
import { useRouteMatch } from "react-router-dom";
import { AthleteActivityPageSkeleton } from "./AthleteActivityPageSkeleton";
import { EditAthletePageSkeleton } from "./edit/EditAthletePageSkeleton";
import { AthleteMembershipsPageSkeleton } from "./AthleteMembershipsPageSkeleton";

const Skeleton = () => {
    const matchAthletes = useRouteMatch("/athletes")?.isExact;
    const matchShowAthlete = useRouteMatch("/athletes/:athleteId")?.isExact;
    const matchEditAthlete = useRouteMatch(
        "/athletes/:athleteId/edit",
    )?.isExact;
    const matchAthleteMemberships = useRouteMatch(
        "/athletes/:athleteId/memberships",
    )?.isExact;

    if (matchAthletes || matchShowAthlete) {
        return <AthleteActivityPageSkeleton />;
    } else if (matchEditAthlete) {
        return <EditAthletePageSkeleton />;
    } else if (matchAthleteMemberships) {
        return <AthleteMembershipsPageSkeleton />;
    } else {
        return null;
    }
};

export const AthleteDashboardPageSkeleton = () => {
    return (
        <div role="status" aria-label="loading" id="athlete-dashboard">
            <MaxWidthPage className="skeleton">
                <Breadcrumbs forceMobileView noBackground />
                <Heading title={<Fake size={40} />} />
                <HeadingNav links={[{ label: <Fake size={12} />, to: "" }]} />
                <Box mt={2}>{<Skeleton />}</Box>
            </MaxWidthPage>
        </div>
    );
};
